import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { key: 0 }

import { computed, shallowReactive, onMounted, watch, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectContextHeader from '@Quest/ProjectPlans/Components/ProjectContextHeader.vue'
    import { useProjectPlanSummaryPageQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import type { ProjectPlanSummaryPageReadModel } from '@Quest/ProjectPlans/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPlanSummaryPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))

    const rm = ref<ProjectPlanSummaryPageReadModel | null>(null)
    const projectPlanId = computed<string | null>(() => rm.value?.ProjectPlanId ?? null)

    const projectName = computed(() => rm.value?.ProjectName ?? '')
    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')
    const activePlanId = computed<string | null>(() => rm.value?.ActiveProjectPlanId ?? null)

    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const userId = computed(() => rm.value?.UserId)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)

    const {
        runProjectPlanSummaryPageQueryV1,
        modelProjectPlanSummaryPageQueryV1
    } = useProjectPlanSummaryPageQueryV1(workspaceId, tchProjectId, projectId)
    

    onMounted(() =>
    {
        document.title = 'Project | TransparentChoice'
        runProjectPlanSummaryPageQueryV1()
    })

    watch(() => route.params.planId, () => 
    {
        runProjectPlanSummaryPageQueryV1({
            ProjectPlanId: route.params.planId as string | null
        })
    })

    watch(modelProjectPlanSummaryPageQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
        }
    })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isWorkspaceMember.value)
      ? (_openBlock(), _createBlock(PortfolioNavigation, {
          key: 0,
          workspaceId: workspaceId.value,
          projectId: tchProjectId.value
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : (isProjectOwner.value)
        ? (_openBlock(), _createBlock(Navigation, { key: 1 }))
        : _createCommentVNode("v-if", true),
    (rm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ProjectContextHeader, {
                projectName: projectName.value,
                planId: projectPlanId.value,
                planName: projectPlanName.value,
                activePlanId: activePlanId.value
              }, null, 8 /* PROPS */, ["projectName", "planId", "planName", "activePlanId"])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, null, -1 /* CACHED */))
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          (rm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(ProjectNavigation, {
                  ActivePage: "summary",
                  class: "mt-4 mb-4",
                  workspaceId: workspaceId.value,
                  tchProjectId: tchProjectId.value,
                  projectId: projectId.value,
                  planId: projectPlanId.value
                }, null, 8 /* PROPS */, ["workspaceId", "tchProjectId", "projectId", "planId"])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})